require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-2022-04-25-ri-muhc-team-receives-discovery-of-the-year-award-from-quebec-science-magazine.json") })
        }
      }, "path---news-2022-04-25-ri-muhc-team-receives-discovery-of-the-year-award-from-quebec-science-magazine");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-2022-04-25-ri-muhc-team-receives-discovery-of-the-year-award-from-quebec-science-magazine!./.cache/json/news-2022-04-25-ri-muhc-team-receives-discovery-of-the-year-award-from-quebec-science-magazine.json
// module id = 476
// module chunks = 231608221292675